import { Injector } from '@angular/core';
import { DataHttpService } from '@valhalla/data/http';

export function createGetSessionUserInfo(injector: Injector) {
	const dataHttpService: DataHttpService = injector.get(DataHttpService);

	return function getSessionUserInfo() {
		return dataHttpService.users
			.getSessionUserInfo()
			.toPromise()
			.then(info => {
				return {
					data: info,
				};
			});
	};
}
